import React from 'react';
import Layout from '../components/Layout/Layout';
import Seo from '../components/Seo/Seo';
import Tools from '../components/Tools/Tools';
import PharmaciesNetwork from '../components/PharmaciesNetwork/PharmaciesNetwork';
import Services from '../components/Services/Services';
import COS_FOOTER_BIEN_ETRE from '../images/COS_FOOTER_BIEN_ETRE.png';

const Reseau = () => {
  return (
    <Layout logo={COS_FOOTER_BIEN_ETRE}>
      <Seo title="COS - Notre Réseau" description="COS - Notre Réseau" />
      <Tools />
      <PharmaciesNetwork />
      <Services />
    </Layout>
  );
};

export default Reseau;
